import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UiService } from '../../core/services/ui.service';

@Component({
  selector: 'app-ui-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (uiService.enabled) {
      <button
        type="button"
        class="ui-toggle-btn"
        (click)="toggle()"
        [attr.aria-label]="label()"
        [title]="label()"
      >
        <i [class]="uiService.isNew() ? 'pi pi-history' : 'pi pi-sparkles'" aria-hidden="true"></i>
        <span class="ui-toggle-label">{{ label() }}</span>
      </button>
    }
  `,
  styles: [`
    .ui-toggle-btn {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      height: 40px;
      margin-right: 0.5rem;
      padding: 0 0.875rem;
      border: 1px solid var(--border-color, currentColor);
      border-radius: 20px;
      background-color: transparent;
      color: var(--icon-color);
      font-size: 0.8125rem;
      font-weight: 500;
      white-space: nowrap;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: var(--bg-hover);
        color: var(--theme-primary-color);
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }

      &:focus-visible {
        outline: 2px solid var(--success-color);
        outline-offset: 2px;
      }

      i {
        font-size: 1rem;
      }
    }

    @media (max-width: 768px) {
      .ui-toggle-label {
        display: none;
      }

      .ui-toggle-btn {
        width: 40px;
        padding: 0;
        justify-content: center;
      }
    }
  `],
})
export class UiToggleComponent {
  protected readonly uiService = inject(UiService);

  protected readonly label = computed(() =>
    this.uiService.isNew() ? 'Switch to classic' : 'Try the new look'
  );

  protected toggle(): void {
    this.uiService.toggle();
  }
}
